
(() => {
  const body = document.body;
  const updateHeader = () => body.classList.toggle('vod-has-scrolled', window.scrollY > 16);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const targets = document.querySelectorAll(
    '[id^="VaultHomeLanes-"], [id^="VaultHomeGuides-"], .vault-home-articles, .collection .product-grid > li, .product__media-item, .footer-block'
  );
  if (!('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('vod-refine-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -7% 0px', threshold: .06 });
  targets.forEach((target, index) => {
    target.classList.add('vod-refine-reveal');
    target.style.transitionDelay = `${Math.min(index % 4, 3) * 55}ms`;
    observer.observe(target);
  });
})();
